import { Outlet, createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/fr/cours/$courseSlug')({
  component: Outlet,
})
